import { render, staticRenderFns } from "./UserScreening.vue?vue&type=template&id=63ae814e&scoped=true"
import script from "./UserScreening.vue?vue&type=script&lang=js"
export * from "./UserScreening.vue?vue&type=script&lang=js"
import style0 from "./UserScreening.vue?vue&type=style&index=0&id=63ae814e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ae814e",
  null
  
)

export default component.exports